<template>
  <div class="pagoda-sub-title"><slot></slot></div>
</template>

<script>
export default {
  name: 'SubTitle'
}
</script>
